import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddPictureButtonComponent } from './add-picture-button.component';

@NgModule({
  declarations: [AddPictureButtonComponent],
  exports: [AddPictureButtonComponent],
  imports: [CommonModule],
})
export class AddPictureButtonModule {}
